import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetDenialLetter,
	DenialLetterParams,
	GetDenialLetterModel,
} from 'domain/usecases/private/authorizations';

export class RemoteGetDenialLetter implements GetDenialLetter {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetDenialLetterModel>,
	) {}

	async get({signal, ...params}: DenialLetterParams): Promise<GetDenialLetterModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			responseType: 'blob',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
